"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportDescripitonTranslations = {
    "en": {
        exportToCsv: "Export to .CSV",
        export: "Export",
        comingSoon: "Coming soon",
        print: "Print",
    },
    "de": {
        exportToCsv: "Nach .CSV exportieren",
        export: "Exportieren",
        comingSoon: "",
        print: "Ausdrucken",
    },
    "nl": {
        exportToCsv: "Exporteren naar .CSV",
        export: "Exporteren",
        comingSoon: "",
        print: "Printen",
    },
    "it": {
        exportToCsv: "Esporta in .CSV",
        export: "Esporta",
        comingSoon: "",
        print: "Stampa",
    },
    "fr": {
        exportToCsv: "Exporter au format .CSV",
        export: "Exporter",
        comingSoon: "",
        print: "Imprimer",
    },
    "es": {
        exportToCsv: "Exportar en archivo de formato .CSV",
        export: "Exportar",
        comingSoon: "",
        print: "Imprimir",
    },
    "ja": {
        exportToCsv: ".CSVへエクスポート",
        export: "エクスポート",
        comingSoon: "",
        print: "印刷",
    },
    "en-GB": {
        exportToCsv: "Export to .CSV",
        export: "Export",
        comingSoon: "Coming soon",
        print: "Print",
    },
    "ru": {
        exportToCsv: "Экспортировать в .CSV",
        export: "Экспортировать",
        comingSoon: "Скоро будет",
        print: "Печать",
    },
};
